/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import { observable, when } from 'mobx';
import { Link } from 'react-router-dom';
import type { TranslatorProps } from 'react-i18next';

import { ElectroButton } from 'components/ExtendedUiElements/customized.js';
import CentralForm from 'components/CentralForm/CentralForm';
import { Roles } from 'permissions/defs';

import styles from 'common-scss/formstyles.module.scss';

@translate()
@inject('emailModel', 'authenticationStore', 'userStore')
@observer
export default class ValidateMagicLink extends React.Component<*> {
  @observable response: ?Object;

  async componentDidMount(): Promise<void> {
    try {
      // NOTE: Set here because for some reason, validating a magic link is done in a different model/service
      this.props.authenticationStore._authenticationInProgress = true;
      this.props.userStore.clearUser();
      await this.props.emailModel.validateMagicLink(this.props.match.params);

      if (this.response && this.response.success) {
        this.props.authenticationStore.saveTokenToLocal();
        this.props.userStore.getActiveUser();

        when(
          () =>
            typeof this.props.userStore.userRoleId !== 'undefined' &&
            this.props.userStore.userRoleId !== Roles.LOGIN,
          () => {
            this.props.history.push('/');
          }
        );
      } else {
        this.response = this.response || { success: false };
      }
    } catch (e) {
      this.response = e;
    }
  }

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;

    if (this.response && !this.response.success) {
      return (
        <CentralForm>
          <div>
            <h1>{t('general:error')}</h1>
            <p>{this.response.message}</p>
            <Link to="/get-magic-link" className={styles['button-anchor']}>
              <ElectroButton label={t('general:actions.request')} color="primary" />
            </Link>
          </div>
        </CentralForm>
      );
    }

    return (
      <CentralForm>
        <div>
          <h1>{t('general:accounts.validating')}</h1>
        </div>
      </CentralForm>
    );
  }
}
